import React, { useState } from 'react'
import { ChevronDown, Building2 } from 'lucide-react'
import { useOrg } from '../context/OrgContext'

const OrgSelector: React.FC = () => {
  const { currentOrg, organizations, setCurrentOrg } = useOrg()
  const [isOpen, setIsOpen] = useState(false)

  if (!currentOrg) {
    return null
  }

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-4 py-2 rounded-md bg-background-tertiary hover:bg-zinc-700 transition-colors"
      >
        <Building2 className="w-4 h-4 text-text-secondary" />
        <span className="text-sm font-medium text-text-primary">{currentOrg.name}</span>
        <ChevronDown className="w-4 h-4 text-text-secondary" />
      </button>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute top-full mt-2 right-0 w-64 bg-background-secondary border border-zinc-700 rounded-md shadow-xl z-20">
            {organizations.map((org) => (
              <button
                key={org.id}
                onClick={() => {
                  setCurrentOrg(org)
                  setIsOpen(false)
                }}
                className={`
                  w-full px-4 py-3 text-left hover:bg-background-tertiary transition-colors
                  ${org.id === currentOrg.id ? 'bg-background-tertiary' : ''}
                `}
              >
                <div className="flex items-center gap-2">
                  <Building2 className="w-4 h-4 text-text-secondary" />
                  <div>
                    <div className="text-sm font-medium text-text-primary">{org.name}</div>
                    <div className="text-xs text-text-muted uppercase">{org.tier}</div>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  )
}

export default OrgSelector
